import { UserClaim } from '@/constants/userClaim';
import type { RouteDefinition } from '../types';

export const registryRoutes = (t: (key: string) => string): RouteDefinition[] => [
  {
    path: 'registries/automatic-processing-codes/:versionId?',
    name: 'AutomaticProcessingCodes',
    component: () => import('../../views/registries/AutomaticProcessingCodes.vue'),
    meta: {
      requiresAuth: true,
      title: t('registry.automaticProcessingCodes')
    }
  },
  {
    path: 'registries/report-type-schedules',
    name: 'ReportTypeSchedules',
    component: () => import('../../views/registries/ReportTypeSchedules.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Report_Type_Review],
      title: t('registry.reportTypeSchedules')
    }
  },
  {
    path: 'registries/budget-users',
    name: 'BudgetUsers',
    component: () => import('../../views/registries/BudgetUsers.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Registry_Review],
      title: t('registry.budgetUsers')
    }
  },
  {
    path: 'registries/municipalities',
    name: 'Municipalities',
    component: () => import('../../views/registries/MunicipalitiesPage.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Registry_Review],
      title: t('registry.municipalities')
    }
  },
  {
    path: 'registries/treasury-branches',
    name: 'TreasuryBranches',
    component: () => import('../../views/registries/TreasuryBranches.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Registry_Review],
      title: t('registry.treasuryBranches')
    }
  }
];
